aboutHandler = {
    $storiesContainer : $('.stories-item-container'),
    $moreButton : $('[href="#more-stories"]'),

    init : function() {
        var self = this;

        if (self.$moreButton.length > 0) {
            self.$moreButton.on('click', function(e) {
                e.preventDefault();
                var counter = 5;

                $(this).toggleClass('even')
                if ($(this).hasClass('even')) {
                    counter = 6;
                } 
                
                self.$storiesContainer.find('.item-container.hide').each(function() {
                    if (counter != 0) {
                        $(this).removeClass('hide');
                        counter--;
                    }
                });

                if (self.$storiesContainer.find('.item-container.hide').length == 0 ) {
                    $(this).addClass('hide');
                }
                $(window).resize();
            });
        }
    }
}